export enum ContentFocus {
  BehaviorPBIS = 'Behavior/PBIS',
  CETA = 'CETA',
  Coaching = 'Coaching',
  CommunicationSupports = 'Communication Supports',
  Data = 'Data',
  EarlyChildhood = 'Early Childhood',
  FAPEintheLRE = 'FAPE in the LRE',
  FoundationsinAutism = 'Foundations in Autism',
  InclusivePractices = 'Inclusive Practices',
  InstructionAcademic = 'Instruction/Academic',
  TeamingMM = 'Teaming/MM',
  NeuroaffirmingPractices = 'Neuroaffirming Practices',
  PeerToPeer = 'Peer to Peer',
  SecondaryTransition = 'Secondary Transition',
  SocialCommunication = 'Social-Communication',
  EBPsVisuals = 'EBPs (e.g., Visuals)',
  UniversalSupports = 'Universal Supports',
  Other = 'Other'
}
